














































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import CRUDMixins from "@/mixins/CRUDMixins";
import { mapState } from "vuex";
import _ from "lodash";
import { parseDateTime } from "@/utils/dayjs";

@Component({
  computed: {
    ...mapState("Auth", {
      activeBusiness: "activeBusiness"
    }),
    ...mapState("Business", {
      business: "business"
    }),
    ...mapState("Country", {
      countries: "countries"
    }),
    ...mapState("SystemData", {
      timezones: "timezones",
      dateFormats: "dateFormats",
      timeFormats: "timeFormats"
    })
  }
})
export default class BusinessUpdateGeneral extends Mixins(CRUDMixins) {
  business!: Model;

  tmpBusiness = {};

  isLoading = false;

  @Watch("business", { deep: true })
  watchBusiness(v) {
    this.tmpBusiness = _.cloneDeep(v);
  }

  mounted() {
    if (this.business) {
      this.tmpBusiness = _.cloneDeep(this.business);
    }
  }

  update() {
    this.isLoading = true;
    this.$store.dispatch("Business/update", this.tmpBusiness).then(() => {
      this.isLoading = false;
      this.$store.commit("SET_SNACKBAR", {
        show: true,
        type: "success",
        message: this.$i18n.t("common_word.success_update")
      });
    });
  }

  goCheck() {
    this.$router.push({
      name: "business-credit-check-result"
    });
  }

  goApply() {
    this.$router.push({
      name: "business-credit-check"
    });
  }

  formatCurrentDate(format) {
    return parseDateTime(format);
  }
}
